<template>
    <a
        :href="
            route(url, {
                invitationToken: invitationToken,
            })
        "
    >
        <button
            v-if="iconOnly"
            type="button"
            class="flex h-11 w-full items-center justify-center rounded-md border border-gray-200 bg-white shadow-sm transition hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-custom-blue-500/30"
            :aria-label="`${login ? $t('vue.sign_in_with') : $t('vue.sign_up_with')} ${label}`"
        >
            <img
                class="h-5 w-5"
                :src="`https://d3ljnultankpar.cloudfront.net/application/images/auth/${provider}.svg`"
                alt=""
            />
        </button>

        <!-- Default (full button) -->
        <AtomicButton v-else size="lg" color="white" class="w-full">
            <template #icon>
                <img
                    class="mr-2 h-6 w-6"
                    :src="`https://d3ljnultankpar.cloudfront.net/application/images/auth/${provider}.svg`"
                    alt="Socialite app auth image by provider"
                />
            </template>
            {{ login ? $t("vue.sign_in_with") : $t("vue.sign_up_with") }}
            {{ label }}
        </AtomicButton>
    </a>
</template>

<script lang="ts" setup>
import route from "ziggy-js";

defineProps({
    login: { type: Boolean, required: false, default: false },
    provider: { type: String, required: true },
    url: { type: String, required: true },
    invitationToken: { type: String, required: false, default: "" },
    label: { type: String, required: true },

    iconOnly: { type: Boolean, required: false, default: false },
});
</script>
